import { render, staticRenderFns } from "./SellingPrice.vue?vue&type=template&id=97a90488&"
import script from "./SellingPrice.vue?vue&type=script&lang=js&"
export * from "./SellingPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports